import React from 'react';
import tw from 'twin.macro';

const StyledDiv = tw.div`font-display min-h-screen text-secondary-500 p-8 overflow-hidden`;

export default function ContainerBody({ children }) {
    return <StyledDiv className="App">{children}</StyledDiv>;
}
